import { generatedAPI } from './endpoints.gen';

export const rulesAPIv0alpha1 = generatedAPI.enhanceEndpoints({});
